import {FC} from "react";
import {LinkProps} from "antd/es/typography/Link";
import {App, Typography} from "antd";

export const LinkWithCopy: FC<LinkProps> = ({ children, ...props }) => {
    const { message } = App.useApp();

    const handleCopy = async () => {
        await navigator.clipboard.writeText(children as string);
        void message.success('Скопировано');
    }

    return (
        <Typography.Link {...props} onClick={handleCopy}>{children}</Typography.Link>
    )
}